const mediaItems = [
  {
    title: '「咒术回战」最新预告 PV',
    desc: '第二季涩谷事变篇正式预告，五条悟封印倒计时',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20anime%20style%20thumbnail%20with%20intense%20action%20scene%2C%20dark%20urban%20cityscape%20at%20night%2C%20mysterious%20blue%20energy%20effects%2C%20Japanese%20anime%20art%20aesthetic%2C%20cinematic%20lighting%2C%20video%20thumbnail%20composition%20with%20play%20button%20area%2C%20vibrant%20colors&width=640&height=360&seq=media-01-jjk&orientation=landscape',
    views: '128万',
    tag: '预告片',
  },
  {
    title: '「我独自升级」名场面剪辑',
    desc: 'S级觉醒者大战暗影军团，全程高燃无尿点',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20battle%20scene%20thumbnail%2C%20dark%20warrior%20with%20glowing%20purple%20energy%2C%20shadow%20army%20in%20background%2C%20dramatic%20lighting%20with%20sparks%2C%20manhwa%20webtoon%20style%2C%20cinematic%20action%20composition%2C%20high%20contrast%2C%20video%20thumbnail%20layout&width=640&height=360&seq=media-02-solo&orientation=landscape',
    views: '96万',
    tag: '名场面',
  },
  {
    title: '「一人之下」动画第五季回顾',
    desc: '天师下山篇章高能合集，道法对决震撼人心',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20anime%20style%20thumbnail%2C%20Taoist%20master%20with%20flowing%20robes%20in%20dramatic%20pose%2C%20mystical%20energy%20surrounding%2C%20ancient%20temple%20setting%2C%20ink%20brush%20painting%20aesthetic%2C%20dynamic%20composition%2C%20rich%20cultural%20elements&width=640&height=360&seq=media-03-yiren&orientation=landscape',
    views: '73万',
    tag: '回顾',
  },
  {
    title: '韩漫改编动画化决定速报',
    desc: '多部人气韩漫宣布动画化，2026年播出时间表公布',
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20collage%20style%20thumbnail%20featuring%20various%20Korean%20manhwa%20character%20designs%2C%20animation%20production%20theme%2C%20bright%20studio%20lighting%2C%20announcement%20style%20layout%2C%20vibrant%20and%20exciting%20atmosphere%2C%20modern%20anime%20art%20style&width=640&height=360&seq=media-04-anime&orientation=landscape',
    views: '89万',
    tag: '速报',
  },
  {
    title: '皮皮漫画年度TOP10盘点',
    desc: '2026上半年最受欢迎漫画排行榜，你看过几部？',
    image: 'https://readdy.ai/api/search-image?query=A%20ranking%20style%20thumbnail%20with%20manga%20book%20covers%20arranged%20in%20a%20visually%20appealing%20grid%2C%20golden%20trophy%20or%20medal%20element%2C%20warm%20spotlight%20effect%2C%20award%20ceremony%20aesthetic%2C%20colorful%20comic%20art%20background%2C%20celebratory%20atmosphere&width=640&height=360&seq=media-05-top10&orientation=landscape',
    views: '156万',
    tag: '盘点',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精彩视频</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            热门漫画动画化资讯、名场面剪辑与年度盘点视频集锦
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-950/60 flex items-center justify-center backdrop-blur-sm group-hover:bg-primary-500/80 transition-all">
                    <i className="ri-play-fill text-2xl text-background-50 ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-background-50 text-xs backdrop-blur-sm">
                  {item.views} 次播放
                </div>
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {mediaItems.slice(3, 5).map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[200px] aspect-video sm:aspect-auto shrink-0 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-11 h-11 rounded-full bg-background-950/60 flex items-center justify-center backdrop-blur-sm group-hover:bg-primary-500/80 transition-all">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs font-medium w-fit mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
                <div className="text-xs text-foreground-400 mt-2">{item.views} 次播放</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}